import type * as maplibregl from "maplibre-gl";

// Порядок разбора одного клика по карте (MapView.vue, map.on("click")).
// Каждый шаг, забравший клик, останавливает разбор:
// 1. линейка или редактор маршрута - у них свой слушатель клика, точкам и
//    остальному клик не достаётся (вершину ставят и поверх вершины/перевала);
// 2. «Метка» - ставит точку;
// 3. чип кластера POI - холостой (не зумит, ничего не открывает);
// 4. точка POI (вершина/перевал/иконка) - карточка точки; важнее линии
//    маршрута под ней;
// 5. покрытие троп маршрутами - попап «маршруты здесь» (только без
//    выбранного маршрута - решает вызывающий);
// 6. курсор выбранного маршрута; клик мимо линии - «тап по пустой карте».
export interface MapClickHandlers {
  rulerActive: () => boolean;
  routeEditorActive: () => boolean;
  pointTool: ((e: maplibregl.MapMouseEvent) => void) | null;
  hitsCluster: (e: maplibregl.MapMouseEvent) => boolean;
  pointTap: (e: maplibregl.MapMouseEvent) => boolean;
  routeCoverage: (e: maplibregl.MapMouseEvent) => boolean;
  routeCursor: (e: maplibregl.MapMouseEvent) => void;
}

export function dispatchMapClick(e: maplibregl.MapMouseEvent, h: MapClickHandlers) {
  if (h.rulerActive() || h.routeEditorActive()) return;
  if (h.pointTool) {
    h.pointTool(e);
    return;
  }
  if (h.hitsCluster(e)) return;
  if (h.pointTap(e)) return;
  if (h.routeCoverage(e)) return;
  h.routeCursor(e);
}
